import { AnyAction } from 'redux';
import { FlagItem, FlagItemState } from '../types/flag.model';
import { FlagOfferActions } from '../actions/flagOffer';
import produce from 'immer';

const initialState: FlagItemState = {
  isLoading: false,
  currentSelected: undefined,
  comments: [],
};

const flagOfferReducer = (state = initialState, action: AnyAction) => {
  switch (action.type) {
    case FlagOfferActions.SET_CURRENT_ITEM: {
      return produce(state, (draft) => {
        if (action.payload) {
          draft.currentSelected = action.payload;
        } else {
          draft.currentSelected = undefined;
          draft.comments = [];
          draft.isLoading = false;
        }
      });
    }
    case FlagOfferActions.IS_LOADING: {
      return produce(state, (draft) => {
        draft.isLoading = action.payload;
      });
    }
    case FlagOfferActions.FLAG_ITEM: {
      const { flagItem, comment }: { flagItem: FlagItem; comment?: string } =
        action.payload;
      return produce(state, (draft) => {
        if (comment) {
          draft.comments.push({
            CreatedOn: new Date(),
            Comment: comment,
            UserName: flagItem.userName,
          });
          draft.currentSelected = flagItem;
        }
      });
    }
    case FlagOfferActions.FETCH_COMMENTS: {
      const { comments, isResolved } = action.payload;
      return produce(state, (draft) => {
        draft.comments = comments.map((el: any) => {
          return {
            CreatedOn: el.CreatedOn,
            Comment: el.Comment,
            UserName: el.UserName,
          };
        });

        if (draft.currentSelected) draft.currentSelected.resolved = isResolved;
      });
    }
    case FlagOfferActions.ADD_COMMENT: {
      const { comment, UserName } = action.payload;
      return produce(state, (draft) => {
        draft.comments.push({
          CreatedOn: new Date(),
          Comment: comment,
          UserName: UserName,
        });
      });
    }
    case FlagOfferActions.RESOLVE_FLAG: {
      const flagItem = action.payload as FlagItem;
      if (!flagItem.id) return;
      return produce(state, (draft) => {
        draft.currentSelected = undefined;
        draft.comments = [];
        draft.isLoading = false;
      });
    }
    case 'LOGOUT': {
      return initialState;
    }
    default: {
      return state;
    }
  }
};

export default flagOfferReducer;
